import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { Paper, Grid, Typography, CircularProgress, Link } from "@mui/material";

import { AvatarStyled, FormStyled, GridImageContainer, GridPaperContainer, SubmitButton } from "../../mainStyle.js";
import Layout from "../../layout/layout.js";
import { ModalDialog } from "../shared/modals/modalDialog.js";

import { resetPassword, updatePassword, verifyResetPasswordToken } from "./resetPasswordController.js";
import { _t } from "../../store/translate.js";
import { useDispatch } from "react-redux";
import { getCurrentJSONData } from "../../store/auth.js";
import LoadingOverlay from "../loadingOverlay/loadingOverlay.js";
import LinearTextInput from "../linearTextInput/linearTextInput.js";

function ResetPassword(props) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const { email, token } = useParams();

	const [openModal, setOpenModal] = useState(false);
	const [modalText, setModalText] = useState({ title: "", text: "" });
	const [isVerified, setIsVerified] = useState(false);

	const handleSubmit = async (event, navigate) => {
		event.preventDefault();
		setLoading(true);
		if (isVerified) {
			var password = event.target.elements.password.value;
			dispatch(updatePassword(email, password, token)).then((res) => {
				if (res.payload && res.payload._id) {
					dispatch(getCurrentJSONData()).then((res2) => {
						navigate("/projectList");
					});
				}
			});
		} else {
			var response = await resetPassword(event?.target?.elements?.email?.value);
			if (response?.status === 200) {
				var title = "";
				var text = response?.data;
				setModalText({ title, text });
				setOpenModal(true);
			}
		}
		setLoading(false);
	};

	const [loading, setLoading] = React.useState(false);
	React.useEffect(() => {
		async function fetchData() {
			if (props.user.user) {
				navigate("/");
			} else {
				if (email && token) {
					var request = await verifyResetPasswordToken(email, token);
					if (request) {
						setIsVerified(true);
					} else {
						navigate("/");
					}
				}
			}
		}
		fetchData();
	}, [props]);

	return (
		<>
			{openModal && <ModalDialog vendor={props.vendor} opened={true} closed={setOpenModal} title={modalText.title} text={modalText.text} />}
			{isVerified ? (
				<Layout>
					{loading ? (
						<CircularProgress style={{ position: "absolute", left: "50%", top: "50%" }} />
					) : (
						<Grid container>
							<Grid item xs={false} sm={4} md={7} component={GridImageContainer} vendor={props.vendor.postfix} />
							<Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
								<Grid container component={GridPaperContainer} direction="column">
									<AvatarStyled>
										<LockOutlinedIcon />
									</AvatarStyled>
									<Typography component="h1" variant="h5">
										{_t("Passwort zurücksetzen")}
									</Typography>
									<FormStyled
										noValidate
										onSubmit={(e) => {
											handleSubmit(e, navigate);
										}}
									>
										<div>
											<LinearTextInput disabled value={email} label={_t("Email Addresse")} id="email" fullParentWidth autoComplete="email" autoFocus={true} />
											<LinearTextInput required label={_t("Passwort")} id="password" fullParentWidth type="password" autoComplete="current-password" />
										</div>

										<SubmitButton type="submit" fullWidth variant="contained" color="primary">
											{_t("Bestätigen")}
										</SubmitButton>
									</FormStyled>
								</Grid>
							</Grid>
						</Grid>
					)}
				</Layout>
			) : (
				<div style={{ position: "relative" }}>
					<Grid container component={GridPaperContainer} style={{ paddingTop: 14 }} direction="column">
						<AvatarStyled>
							<LockOutlinedIcon />
						</AvatarStyled>
						<Typography component="h1" variant="h5">
							{_t("Passwort zurücksetzen")}
						</Typography>
						<FormStyled
							noValidate
							onSubmit={(e) => {
								handleSubmit(e, navigate);
							}}
						>
							<LinearTextInput required label={_t("Email Addresse")} id="email" fullParentWidth autoComplete="email" autoFocus={true} />

							<SubmitButton type="submit" fullWidth variant="contained" color="primary">
								{_t("Bestätigen")}
							</SubmitButton>
							<Grid container justifyContent="flex-end">
								<Grid item>
									<Link
										style={{ cursor: "pointer" }}
										variant="body2"
										onClick={() => {
											props.onClickLogin();
										}}
									>
										{_t("Zurück zur Anmeldung")}
									</Link>
								</Grid>
							</Grid>
						</FormStyled>
						{loading ? <LoadingOverlay /> : undefined}
					</Grid>
				</div>
			)}
		</>
	);
}

export default ResetPassword;
